<template>
  <div class="row p-5" id="cover-page">
    <div
      class="col-sm-10 col-md-12 d-flex justify-content-center text-center align-items-center button-container"
    >
      <img
        class="cover-image border-radius-2 border w-50 book-end"
        :src="
          'https://assets.beereaders.com/lbr/image/' +
            resource_dir +
            '/cover_medium.jpg'
        "
      />
      <div class="p-3 message-container border-radius-2 bg-white">
        <h3 class="text-center">Has llegado al final del libro</h3>
        <h3 class="text-center">
          Presiona el boton para volver al incio y continuar
        </h3>
      </div>
      <router-link
        :to="'/dashboard/books'"
        class="btn br-button-primary m-0 px-4 py-1 border-radius-5"
        >Volver atras</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "br-book-end-cover",
  props: ["resource_dir"],
  data() {
    return {
      server_image: "",
    };
  },
};
</script>

<style lang="css">
.message-container {
  position: absolute;
  bottom: 45vh;
  font-size: 32px !important;
  box-shadow: black -1px 3px 12px 0px;
}
.book-end {
  filter: blur(5px);
}
.button-container a,
.button-container button,
.button-container .btn,
.button-container .button {
  position: absolute;
  bottom: 3vh;
  font-size: 22px !important;
  box-shadow: black -1px 3px 12px 0px;
}
</style>
